import ApiService from "./api.service"

export const NewsService = {
  list(page = 1, itemCount = 10, category = null) {
    return ApiService.get(`articles`, {
      params: { page: page, item_count: itemCount, category: category },
    })
  },
  show(slug) {
    return ApiService.get(`articles/${slug}`)
  },
}
